import type { TFunction } from "i18next";
import * as yup from "yup";

// Boolean schema that tolerates null/undefined inputs by coercing them to false
// before yup's strict type check runs. Defends against:
//   - persisted localStorage state (useOrderingStore) carrying null from a
//     prior app version
//   - any future API response feeding form initial values where backend may
//     send null for unset consents (legacy accounts)
// Without the transform, yup raises "must be a `boolean` type, but the final
// value was: `null`" inline on the consent checkbox, dead-locking the form.
export const safeBooleanSchema = () => yup.boolean().transform((v) => (v == null ? false : v));

export const getCheckboxRequiredSchema = (t: TFunction, required: boolean) =>
  required ? safeBooleanSchema().oneOf([true], t("ERRORS.COMMONS.REQUIRED")) : safeBooleanSchema();
